module.exports = __webpack_public_path__ + "img/st-pro-logo.44bc9115.svg";